/* ---- Cart Drawer - Zakya & Co ---- */
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var bodyEl   = document.getElementById('zcd-body');
  var footerEl = document.getElementById('zcd-footer');

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function updateHeaderCount(count) {
    var badge = document.getElementById('site-header-cart-count');
    var btn   = document.getElementById('site-header-cart-btn');
    if (!btn) return;
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.id = 'site-header-cart-count';
        badge.className = 'site-header__cart-count';
        btn.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function checkoutUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'checkout';
  }

  function render(cart) {
    updateHeaderCount(cart ? cart.item_count : 0);
    if (!cart || !cart.item_count) {
      bodyEl.innerHTML = '<div class="zcd__empty"><p>Votre panier est vide</p></div>';
      footerEl.innerHTML = '';
      return;
    }
    var items = cart.items.map(function (item) {
      var img = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/\.jpg/, '_160x.jpg').replace(/\.png/, '_160x.png').replace(/\.webp/, '_160x.webp')
        : (item.image || '');
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="zcd__item-variant">' + item.variant_title + '</p>' : '';
      return '<li class="zcd__item">'
        + (img ? '<img class="zcd__item-img" src="' + img + '" alt="" loading="lazy">' : '<div class="zcd__item-img"></div>')
        + '<div class="zcd__item-info">'
        + '<p class="zcd__item-title">' + item.product_title + '</p>'
        + variantHtml
        + '<p class="zcd__item-price">' + formatMoney(item.final_line_price) + '</p>'
        + '<div class="zcd__item-actions">'
        + '<div class="zcd__qty">'
        + '<button class="zcd-qty-btn" data-key="' + item.key + '" data-qty="' + Math.max(0, item.quantity - 1) + '">−</button>'
        + '<span>' + item.quantity + '</span>'
        + '<button class="zcd-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>'
        + '</div>'
        + '<button class="zcd__remove" data-key="' + item.key + '">Retirer</button>'
        + '</div></div></li>';
    }).join('');

    bodyEl.innerHTML = '<ul class="zcd__items">' + items + '</ul>';

    /* Checkout via form natif Shopify (method native, fonctionne dans toutes les locales) */
    footerEl.innerHTML =
      '<div class="zcd__subtotal">'
      + '<span class="zcd__subtotal-label">Sous-total</span>'
      + '<span class="zcd__subtotal-price">' + formatMoney(cart.total_price) + '</span>'
      + '</div>'
      + '<form action="/cart" method="post" style="margin:0;">'
      + '<button type="submit" name="checkout" class="zcd__checkout">Passer la commande</button>'
      + '</form>'
      + '<p class="zcd__note">Livraison calculée au checkout</p>';
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }
  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(fetchCart).then(render);
  }
  function addToCart(formData) {
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(fetchCart)
      .then(function (cart) { render(cart); open(); });
  }

  /* Capture phase */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#zcd-overlay') || e.target.closest('#zcd-close')) {
      close(); return;
    }
    var qtyBtn = e.target.closest('.zcd-qty-btn');
    if (qtyBtn) { changeQty(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.qty, 10)); return; }
    var rmBtn = e.target.closest('.zcd__remove');
    if (rmBtn) { changeQty(rmBtn.dataset.key, 0); return; }

    if (e.target.closest('#pd-atc-btn')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var form = document.getElementById('pd-form');
      if (form) addToCart(new FormData(form));
      return;
    }
    if (e.target.closest('.pd-sticky-atc__btn')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var stickyForm = document.getElementById('pd-form');
      if (stickyForm) addToCart(new FormData(stickyForm));
      return;
    }
    if (e.target.closest('#site-header-cart-btn')) {
      e.preventDefault();
      fetchCart().then(render).then(open);
      return;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.ZCDCartDrawer = { open: function () { fetchCart().then(render).then(open); }, close: close };
})();
